import type { OrderCardVM } from '@/components/cards/orderCardModel';
import type { BookDisplaySnapshot } from '@/stores/marketStore';
import { mirrorCents, roundToCentiCents } from '@/lib/pricing/subCent';

/** Rendering only. The current account/order fields always come from vm;
 * the strict VM remains the input to alert and execution consumers. */
export function withOrderBookDisplay(
  vm: OrderCardVM,
  display: BookDisplaySnapshot,
  metrics: { queue: number | null; queueAbove: number | null; queueBehind: number | null; total: number | null } | undefined,
): OrderCardVM {
  if (vm.venue !== 'kalshi' || !display.retained || !display.book) return vm;
  const levels = vm.isSell
    ? (vm.side === 'yes' ? display.book.no : display.book.yes)
    : (vm.side === 'yes' ? display.book.yes : display.book.no);
  const best = levels.reduce<number | null>((max, level) => max == null ? level.price : Math.max(max, level.price), null);
  const top = best == null ? null : vm.isSell ? mirrorCents(best) : best;
  return {
    ...vm,
    bookRetained: true,
    bookDiff: top == null || vm.bidCents == null ? null
      : Math.max(0, roundToCentiCents(vm.isSell ? vm.bidCents - top : top - vm.bidCents)),
    activeInSale: vm.filledQty > 0 && metrics?.queueAbove === 0,
    queue: metrics?.queue ?? vm.queue,
    queueAbove: metrics?.queueAbove ?? null,
    queueBehind: metrics?.queueBehind ?? null,
    queueTotal: metrics?.total ?? null,
  };
}
